// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2Mqu3","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3FnV5"};